module.exports = __webpack_public_path__ + "static/img/m3.7c8fbb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/m3.jpg
// module id = hHdz
// module chunks = 1